import '@domain/utils/yup.setup';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { GameSelection } from '@domain/game.selection/game.selection';
import { AuthProvider } from '@domain/auth/auth.provider';
import ErrorBoundary from '@components/error/error.boundary';
import GlobalStyle from '@styles/global';
import Routes from './routes';

const App = () => {
  return (
    <ErrorBoundary>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <GameSelection>
          <AuthProvider>
            <SnackbarProvider maxSnack={3}>
              <Routes />
            </SnackbarProvider>
          </AuthProvider>
        </GameSelection>
      </BrowserRouter>
      <GlobalStyle />
    </ErrorBoundary>
  );
};

export default App;
